import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Carousel from "../components/carousel/Carousel";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getVehiclesFromDb } from "../api/getVehiclesFromDb";

const IFrame = () => {
  const { clientId, assetId, image_type } = useParams<{ clientId: string; assetId: string; image_type?: string }>();
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState<any[]>([]);

  if (!clientId || !assetId) return <></>;

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const body = {
          page: 1,
          per_page: 1,
          system_code: clientId,
          asset_id: assetId
        };

        const { vehicles } = await getVehiclesFromDb(body)
        const vehicle = vehicles[0]

        const imageSets: Record<string, any[]> = {
          ext: vehicle.imageExterior || [],
          pano: vehicle.imagePano || [],
          man: vehicle.imageManual || [],
          crop: vehicle.imageCrop || [],
          feat: vehicle.imageFeatured || [],
          uc: vehicle.imageUndercarriage || [],
          bgr: vehicle.imageBgr || []
        };

        let finalImages: any[] = [];

        if (!image_type || image_type === "all") {
          finalImages = Object.values(imageSets).flat();
        } else {
          const types = image_type.split("-");
          for (const type of types) {
            if (imageSets[type]) {
              finalImages = [...finalImages, ...imageSets[type]];
            }
          }
        }

        setImages(finalImages);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
        setLoading(false);
      }
    };

    fetchVehicleData();
  }, [clientId, assetId, image_type]);

  if (loading) return <CircularProgress />;

  if (images.length === 0) {
    return <Typography variant="h6">No images available for this category</Typography>;
  }

  return (
    <Box
      sx={{
        width: `${windowSize.width}px`,
        height: `${windowSize.height}px`,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Carousel images={images} />
    </Box>

  );
};

export default IFrame;
